import { User } from "./user";
import { Package } from "./package";

export interface LoginCredentials {
  email: string;
  password: string;
  rememberMe?: boolean;
}

export interface ResetPassword {
  password: string;
  confirmPassword: string;
}

export enum UserRole {
  ADMIN = 1,
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

export interface AuthResponse {
  user: User;
  tokens: AuthTokens;
}

export interface ApiError {
  message: string;
  code?: string;
  statusCode?: number;
  errors?: Record<string, string[]>;
}

export interface ApiResponse<T = any> {
  data: T;
  message?: string;
  success: boolean;
}

export enum Language {
  ENGLISH = 1,
  ARABIC = 2,
}

export interface PaginationParams {
  page: number;
  limit: number;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface SelectOption {
  value: string | number;
  label: string;
  disabled?: boolean;
}

export interface TableColumn<T = any> {
  key: keyof T | string;
  title: string;
  sortable?: boolean;
  width?: string;
  render?: (value: any, record: T) => React.ReactNode;
}

export interface FormField {
  name: string;
  label: string;
  type:
    | "text"
    | "email"
    | "password"
    | "number"
    | "select"
    | "textarea"
    | "checkbox"
    | "radio"
    | "date";
  placeholder?: string;
  required?: boolean;
  options?: SelectOption[];
  validation?: any;
}

export interface ToastOptions {
  title?: string;
  message: string;
  type: "success" | "error" | "warning" | "info";
  duration?: number;
}

export enum PageId {
  DASHBOARD = 2,
  LICENSES = 3,
  COMPANIES = 4,
  EMPLOYEES = 5,
  LOOKUPS = 6,
  USERS = 7,
  PACKAGES = 8,
  CONTACTUS  = 9,
}

export enum ActionCode {
  VIEW = "VW0",
  ADD = "ADD",
  EDIT = "EDT",
  DELETE = "DLT",
  EXPORT = "EXP",
  IMPORT = "IMP",
}

export enum Lookups {
  EmployeeTitles = 'Employees_Title', 
  CompanyStatus = 'Company_Statuses', 
}

export enum CompanyStatus {
   Demo = 5, 
   Active = 6, 
}

export interface PageAction {
  id: number;
  pageId: number;
  actionId: number;
  actionCode: string;
  actionName: string;
  hasPermission: boolean;
}

export interface PageWithPermissions {
  id: number;
  code: string;
  isActive: boolean;
  order: number;
  showInMenu: boolean;
  mainMenuId: number | null;
  pageName: string;
  actions: PageAction[];
}

export interface MenuItem {
  path: string;
  label: string;
  icon?: React.ReactNode;
  pageId?: number;
  permissions?: PageAction[];
}
